<template>
  <select class="e-select"
         type="text"
         :class="hasError ? 'is-invalid' : ''"
         :style="inputStyle"
         :name="name"
         @change="change"
         ref="element"
         v-bind:disabled="disabled"
         v-model="model[name]">
    <option
      v-if="getPlaceholder"
      v-bind:disabled="disablePlaceholderOption"
      value=""
    >{{getPlaceholder}}</option>
    <template v-if="options">
      <option
        v-for="option in options"
        :value="option[optionValueKey]">{{$options.filters.stripHtml(option[optionTextKey])}}</option>
    </template>
  </select>
</template>

<script>
  export default {
    name: 'e-select',
    data () {
      return {
        error: null
      }
    },
    props: {
      disablePlaceholderOption: {
        type: Boolean,
        default: true
      },
      inputStyle: {
        type: Object,
        default: () => {}
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validationRule: {
        type: String,
        default: 'string'
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // (Array|Object)
      options: null,
      placeholder: {
        type: String,
        default: null
      },
      optionValueKey: {
        type: String,
        default: 'id'
      },
      optionTextKey: {
        type: String,
        default: 'name'
      },
      hidePlaceholder: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      getPlaceholder () {
        if (this.hidePlaceholder) {
          return false
        }
        if (this.placeholder === null) {
          return this.$translate('Выберите один из вариантов')
        }
        return this.$translate(this.placeholder)
      },
      hasError () {
        if (this.error) {
          return true
        }
        return false
      }
    },
    created () {
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      change ($event) {
        this.$emit('change', $event)
        // set label for select field
        // used in hmao demo
        this.model[`labelFor${this.name}`] = ''
        if (this.model[this.name] && this.options) {
          this.options.forEach(o => {
            if (o[this.optionValueKey] == this.model[this.name]) {
              this.model[`labelFor${this.name}`] = o[this.optionTextKey]
            }
          })
        }
        // end
        if (this.onChangeValidation) {
          this.validate()
        }
      },
      getElement(){
        return this.$refs.element
      },
      validate () {
        let msg = ''
        if (this.required) {
          if (typeof this.model[this.name] == 'undefined') {
            msg += 'Заполните поле'
          } else if (this.model[this.name] === null) {
            msg += 'Заполните поле'
          } else if (this.model[this.name].toString().length < 1) {
            msg += 'Заполните поле'
          }
        }

        return {
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement()
        }
      }
    }
  }
</script>
